<template>
	<div :class="['label-input', classObject]">
		<label v-if="!inputFirst" :for="id_">{{ label }}</label>
		<input
			v-model="value_"
			:id="id_"
			:type="type"
			:name="name_"
			:disabled="disabled"
			v-bind="attrs"
			:class="inputClassObject"
		/>
		<label v-if="inputFirst" :for="id_">{{ label }}</label>
		<MErrors v-if="errors_" :errors="errors_" />
	</div>
</template>

<script>
import { createNameFromVModelExpr } from '../../index';
import MErrors from './MErrors';
export default {
	name: 'MInput',
	components: { MErrors },
	data() {
		return {
			id_: this.id,
			name_: this.name,
			value_: this.value
		}
	},
	props: {
		id: {
			type: String,
			default: ''
		},
		name: {
			type: String,
			required: false
		},
		label: {
			type: String,
			default: ''
		},
		type: {
			type: String,
			default: 'text'
		},
		attrs: {
			type: Object,
			default() {
				return {}
			}
		},
		inputFirst: {
			type: Boolean,
			default: false
		},
		value: {
			type: String,
			default: ''
		},
		errors: {
			type: Object,
			default() {
				return {}
			}
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		errors_() {
			return this.errors.getOwnPropertyDescriptor(this.name_)
				? this.errors[this.name_]
				: false;
		},
		inputClassObject() {
			return this.errors_ ? ['warning'] : [];
		},
		classObject: function () {
			return [this.type, 'input__type'];
		}
	},
	watch: {
		value_(new_) {
			this.$emit('input', new_);
		},
		value(new_) {
			this.value_ = new_;
		}
	},
	created() {
		const id = createNameFromVModelExpr(this);
		const name = this.$vnode.data.model.expression;

		if (id && !this.id_) this.id_ = id;

		if (name && !this.name_) this.name_ = name;
	}
}
</script>

<style scoped></style>
